import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';

function Login() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { login, error } = useAuthStore();
  const [formData, setFormData] = useState({ email: '', password: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(formData.email, formData.password);
    if (result.success) {
      navigate('/lessons');
    }
  };

  return (
    <div className="container mx-auto px-4 py-12 max-w-md">
      <div className="bg-white dark:bg-stone-900 rounded-2xl border border-stone-200 dark:border-stone-800 p-8">
        <h1 className="font-display text-2xl font-semibold mb-8 text-center text-stone-800 dark:text-stone-100">
          {t('auth.loginTitle')}
        </h1>

        {error && (
          <div className="bg-red-50 dark:bg-red-950/40 text-red-700 dark:text-red-300 text-sm p-3 rounded-xl mb-5">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-stone-600 dark:text-stone-300 text-sm font-medium mb-1.5">
              {t('auth.email')}
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 bg-white dark:bg-stone-800 text-stone-800 dark:text-stone-100 border border-stone-200 dark:border-stone-700 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand-300 focus:border-brand-400"
              placeholder="example@email.com"
            />
          </div>

          <div>
            <label className="block text-stone-600 dark:text-stone-300 text-sm font-medium mb-1.5">
              {t('auth.password')}
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 bg-white dark:bg-stone-800 text-stone-800 dark:text-stone-100 border border-stone-200 dark:border-stone-700 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand-300 focus:border-brand-400"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-brand-700 text-white font-semibold py-2.5 rounded-xl hover:bg-brand-800 transition-colors"
          >
            {t('auth.submit')}
          </button>
        </form>

        <p className="text-center mt-6 text-sm text-stone-500 dark:text-stone-400">
          {t('auth.noAccount')}{' '}
          <Link to="/register" className="text-brand-700 dark:text-brand-300 font-semibold hover:underline">
            {t('auth.register')}
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
